import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Allowed: ASCII alphanum, Hebrew, `_`, `.`, `-`. Everything else (including
// `"`, `'`, `+`, whitespace, etc.) is replaced with a space and collapsed.
// `"` / `'` / `+` MUST be excluded: TanStack Router's `encodePathLikeUrl` does
// not percent-encode them, but browsers re-normalise URLs and re-encode `"`,
// causing an infinite 307 redirect loop between the decoded and canonical URL
// forms in the route loader.
export const urlSanitize = (url: string) =>
  url
    .replace(/[^a-zA-Z0-9\u0590-\u05FF_.-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
